import core from '@gin-betting/core';
import React from 'react';

import { BettingWidgets } from 'app-constants';
import { Widget } from 'components';
import SearchMobile from './SearchMobile';
import SettingsButtonMobile from './SettingsButtonMobile';
import './headerMobile.scss';

interface Props {}

const { getBettingOptions } = core.utils;

const HeaderMobile: React.FC<Props> = () => {
    const { isAuthorized } = getBettingOptions();

    if (!isAuthorized) return null;

    return (
        <Widget
            widget={BettingWidgets.MOBILE_HEADER}
            replacePortalContent={true}
        >
            <div styleName="container">
                <SearchMobile />
                <SettingsButtonMobile />
            </div>
        </Widget>
    );
};

export default React.memo(HeaderMobile);
